import { postApi, getApi } from "../http";

export const postHome = data => postApi("/Index/index", data);

/** 获取资讯列表 */
export const postNewsList = data => postApi("/news/getNewsList", data);

/** 获取热门资讯列表 */
export const posthotNewsList = data => postApi("/news/hotNewsList", data);

/** 获取资讯详情 */
export const postNewsDetail = data => postApi("/news/getNewsDetail", data);

/** 获取资讯详情 */
export const postrelateNewsList = data => postApi("/news/relateNewsList", data);

/** 获取视频列表 */
export const postSp = data => postApi("/Index/sp", data);

/** 获取视频详情 */
export const postSpDetail = data => postApi("/Index/spDetail", data);

/** 获取美图列表 */
export const posttjList = data => postApi("/Index/tjList", data);

/** 获取美图详情 */
export const tjDetail = data => postApi("/Index/tjDetail", data);

/** 获取微信jssdk配置参数 */
export const jssdkConfig = data => postApi("/auth/jssdkConfig", data);

/** 获取游呗播报列表 */
export const postybbbList = data => postApi("Index/ybbbList", data);
